// Both types behave the same; only the name differs. Code and API still call every tech stop a fuel stop.
export const TECH_STOP_TYPE = {
  FUEL: 'FUEL',
  CUSTOMS: 'CUSTOMS',
} as const;

export type TechStopType = typeof TECH_STOP_TYPE[keyof typeof TECH_STOP_TYPE];

export interface ITechStopTypeOption {
  type: TechStopType;
  label: string;
}

/** In the order the Add Tech Stop menu lists them. */
export const TECH_STOP_TYPE_OPTIONS: Array<ITechStopTypeOption> = [
  { type: TECH_STOP_TYPE.FUEL, label: 'Fuel Stop' },
  { type: TECH_STOP_TYPE.CUSTOMS, label: 'Customs' },
];

// A stop with no type was saved before types existed, and is a fuel stop.
export const techStopTypeOption = (type: TechStopType | null | undefined): ITechStopTypeOption =>
  TECH_STOP_TYPE_OPTIONS.find(option => option.type === type) ?? TECH_STOP_TYPE_OPTIONS[0];
